import {
  ADD_ACCOUNT_TO_USER,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  CHANGE_USER_WORK_STATUS,
  CREATE_USER, DELETE_ACCOUNT_FROM_USER, EDIT_SUPPORT_LIMIT,
  EDIT_USER, EDIT_USER_ACCOUNT_ACCESS,
  LOAD_USERS_LIST, RESET_SUPPORT_LIMIT,
} from './user';
import {
  ADD_ACCOUNT,
  ADD_ACCOUNT_WITHDRAW,
  DELETE_ACCOUNT,
  EDIT_ACCOUNT, LOAD_ACCOUNT_PAYINS, LOAD_ACCOUNT_PAYOUTS,
  LOAD_ACCOUNTS_LIST,
  LOAD_ACCOUNTS_NAMES, REQUEST_EXTERNAL_WALLET
} from "./accounts";
import { LOAD_WITHDRAWS_LIST, SWITCH_NOTE } from "./withdraws";


const path = {
  [AUTH_LOGIN]: 'api/users/login',
  [AUTH_LOGOUT]: 'api/users/logout',
  [LOAD_USERS_LIST]: 'api/users',
  [CREATE_USER]: 'api/users',
  [EDIT_USER]: 'api/users/:id:', // !!!name
  [CHANGE_USER_WORK_STATUS]: 'api/users/settings/work_status/:status:', // DELETE
  [LOAD_ACCOUNTS_LIST]: 'api/accounts',
  [LOAD_ACCOUNTS_NAMES]: 'api/accounts/names',
  [ADD_ACCOUNT]: 'api/accounts',
  [ADD_ACCOUNT_WITHDRAW]: 'api/accounts/:name:/withdraw',
  [LOAD_ACCOUNT_PAYOUTS]: 'api/accounts/:name:/payouts',
  [LOAD_ACCOUNT_PAYINS]: 'api/accounts/:name:/payins',
  [EDIT_ACCOUNT]: 'api/accounts/:name:',
  [DELETE_ACCOUNT]: 'api/accounts/:name:',
  [EDIT_SUPPORT_LIMIT]: 'api/users/:id:/limit/edit',
  [RESET_SUPPORT_LIMIT]: 'api/users/:id:/limit/reset',
  [ADD_ACCOUNT_TO_USER]: 'api/users/:id:/accounts/add',
  [DELETE_ACCOUNT_FROM_USER]: 'api/users/:id:/accounts/delete',
  [EDIT_USER_ACCOUNT_ACCESS]: 'api/users/:id:/accounts/access',
  [LOAD_WITHDRAWS_LIST]: 'api/withdraws',
  [SWITCH_NOTE]: 'api/withdraws/:id:/notes/:type:',
  [REQUEST_EXTERNAL_WALLET]: 'api/wallet/request',

};
export default path;
